import { FC, useEffect, useState } from 'react'
import { Avatar, Card, Modal } from 'antd'
import { baseTime } from 'lib'
import { globalToaster } from 'components/elements/global'
import { TUnreadChatRequestData } from '../types'
import { useNotificationChatActionMutation } from '../api'
import { ChatNotificationAction } from './ChatNotificationAction'

const { Meta } = Card
const ChatReqNotiModal: FC<{
 item?: TUnreadChatRequestData
 show: boolean
 onHide: () => void
 isDirectChat?: boolean
}> = ({ item, onHide, show, isDirectChat }) => {
 const { data } = item || {}
 const [notificationChatAction] = useNotificationChatActionMutation()

 const [status, setStatus] = useState<
  'pending' | 'accepted' | 'rejected' | 'leadtransferred'
 >('pending')
 const handleAcceptJoin = async () => {
  notificationChatAction({
   lead_id: data?.lead_id,
   notification_id: item?.latest_notification_id,
   type: 'joined',
  })
   .unwrap()
   .then((res) => {
    if (res?.status === 'success') {
     if (res?.leadtransferred) {
      setStatus('leadtransferred')
     } else {
      onHide?.()
     }
    }
   })
   .catch((err) => {
    onHide?.()
   })
 }
 const handleDeclineJoin = () => {
  notificationChatAction({
   lead_id: data?.lead_id,
   notification_id: item?.latest_notification_id,
   type: 'joined',
  })
   .unwrap()
   .then((res) => {
    if (res?.status === 'success') {
     if (res?.leadtransferred) {
      setStatus('leadtransferred')
      globalToaster?.({ content: res?.message, type: 'error' })
     } else {
      setStatus('rejected')
      globalToaster?.({ content: res?.message, type: 'success' })
     }
    } else {
     globalToaster?.({ content: res?.message, type: 'error' })
    }
    onHide?.()
   })
   .catch((err) => {
    onHide?.()
   })
 }

 useEffect(() => {
  if (data && data?.status) {
   setStatus(data?.status as any)
  }
 }, [data])

 //  const handleAcceptDirectChatInvite = async (): Promise<void> => {
 //   acceptDirectChatInvite({
 //    notification_id: item?.latest_notification_id ?? '',
 //    user_id: item?.data?.user?.id ?? 0,
 //   })
 //    .unwrap()
 //    .then((res) => {
 //     if (res?.success === true) {
 //      if (res?.leadtransferred) {
 //       setStatus('leadtransferred')
 //      } else {
 //       setStatus('accepted')

 //       // updateChatList?.({
 //       //  userId: item?.data?
 //       //  userData: {
 //       //   user_id: item?.data?.user?.id ?? 0,
 //       //   user_name: item?.data?.user?.name ?? '',
 //       //  },
 //       //  chatType: 'direct',
 //       // })
 //       onHide?.()
 //      }
 //      onHide?.()
 //     }
 //    })
 //  }

 return (
  <Modal
   onCancel={onHide}
   visible={show}
   centered
   footer={false}
   className="cht-request-modal"
  >
   <Card bordered={false} style={{ padding: 0, boxShadow: 'none' }}>
    <Meta
     avatar={
      <Avatar
       size={50}
       //  icon={isDirectChat ? Utils.shortName(item?.data?.user?.name || '') : 'v'}
       className="bg-primary"
      />
     }
     title={data?.title}
     description={
      <>
       <div className="notfn-description">data?.body</div>
       <div className="mb-1">
        {item?.created_at && baseTime(item?.created_at).fromNow()}
       </div>
       <ChatNotificationAction
        // acceptLoading={acceptLoading}
        // acceptLoading={acceptLoading || acceptDirectChatLoading}
        // status={status}
        acceptInvite={handleAcceptJoin}
       />
      </>
     }
    />
   </Card>
  </Modal>
 )
}

export default ChatReqNotiModal
